var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDaniblifting(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "xMidYMid meet",
    "data-bbox": "0 0 401.93 111.6",
    viewBox: "0 0 401.93 111.6",
    xmlns: "http://www.w3.org/2000/svg",
    "data-type": "color",
    role: "presentation",
    "aria-hidden": "true",
    "aria-label": "",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M135.18 111.59h-11.95V60.84h11.95z",
    fill: "#fff",
    "data-color": 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.6 111.59h-12.09V60.84h32.93v10.8H154.6v11.75h18.28v10.58H154.6z",
    fill: "#fff",
    "data-color": 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.32 111.59h-11.95V71.86h-11.24V60.84h34.35v11.02h-11.16z",
    fill: "#fff",
    "data-color": 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.83 111.59h-11.95V60.84h11.95z",
    fill: "#fff",
    "data-color": 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.32 111.59h-11.17V60.84h12.8l12.73 27.7h.5v-27.7h11.17v50.75h-12.73l-12.8-27.7h-.5z",
    fill: "#fff",
    "data-color": 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M311.97 111.59h-24.18l-5.76-5.87V66.71l5.76-5.87h24.18l5.69 5.87v12.33h-11.95v-6.6l-.99-1.01h-9.67l-1.07 1.01v27.62l1.07 1.09h9.67l1.07-1.09v-6.45h-5.83v-9.86h17.71v21.97l-5.69 5.87Z",
    fill: "#fff",
    "data-color": 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.12 111.59H84.27V60.84h11.95v39.52h20.91v11.24Z",
    fill: "#fff",
    "data-color": 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.13 50.83h-12.25l-1.78-11.18h-11.89l-1.78 11.18h-12.32L152.08 0h22.15zm-21.37-40.37-2.85 18.3h8.48l-2.85-18.3z",
    fill: "#fff",
    "data-color": 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.22 50.83h-11.18V0h12.82l12.75 27.74h.5V0h11.18v50.83h-12.75l-12.82-27.74h-.5z",
    fill: "#fff",
    "data-color": 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.59 50.83h-11.97V0h11.97z",
    fill: "#fff",
    "data-color": 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294.16 50.83h-29.98V0h29.84l5.7 5.88v14.3l-4.84 5.01v.15l4.98 5.01v14.6zm-18.02-40.59v10.24h10.61l1.07-1.09v-8.06l-1.07-1.09zm0 19.82v10.53h10.76l1-1.09v-8.35l-1-1.09z",
    fill: "#fff",
    "data-color": 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.05 51.02h-29.98V.19h29.98l5.7 5.88v39.07zm-18.02-39.94v29.05h10.75l1-1.02V12.1l-1-1.02z",
    fill: "#fff",
    "data-color": 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 50.46v10.56c0 9.68 7.84 17.6 17.71 17.6V32.87C7.84 32.87 0 40.78 0 50.46",
    fill: "#f7941d",
    fillRule: "evenodd",
    "data-color": 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.16 111.48H59.9l-3.08-3.08V3.08L59.9 0h11.26l3.08 3.08V108.4z",
    fill: "#f7941d",
    fillRule: "evenodd",
    "data-color": 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.24 99.68H31.29l-2.74-2.74v-82.4l2.74-2.74h11.95l2.74 2.74v82.4z",
    fill: "#f7941d",
    fillRule: "evenodd",
    "data-color": 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M401.93 61.02V50.46c0-9.68-7.84-17.6-17.71-17.6v45.75c9.87 0 17.71-7.92 17.71-17.6Z",
    fill: "#f7941d",
    fillRule: "evenodd",
    "data-color": 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.77 0h11.26l3.08 3.08V108.4l-3.08 3.08h-11.26l-3.08-3.08V3.08c1.2-1.2 1.87-1.88 3.08-3.08",
    fill: "#f7941d",
    fillRule: "evenodd",
    "data-color": 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M358.69 11.81h11.95l2.74 2.74v82.4l-2.74 2.74h-11.95l-2.74-2.74V14.54l2.74-2.74Z",
    fill: "#f7941d",
    fillRule: "evenodd",
    "data-color": 2
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDaniblifting);
export default __webpack_public_path__ + "static/media/daniblifting.34c8ed12c190f4a9b1527bb7560cb918.svg";
export { ForwardRef as ReactComponent };